export default function getDatePath(date: Common.DateObj): string {
  return `${date.year}-${date.month}-${date.date}`;
}
